import { useEffect, useState } from "react";

const BallDropAnimation = () => {
  const [balls, setBalls] = useState([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const newBalls = Array.from({ length: 20 }).map((_, index) => ({
        id: index,
        left: Math.random() * 100 + "vw",
        delay: Math.random() * 2 + "s",
        size: Math.random() * 30 + 20 + "px",
      }));
      setBalls(newBalls);

      setTimeout(() => {
        setBalls([]);
      }, 4000);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="absolute top-0 left-0 w-full h-screen pointer-events-none overflow-hidden z-50">
      {balls.map(ball => (
        <div
          key={ball.id}
          className="absolute flex items-center justify-center animate-fall opacity-0"
          style={{ 
            left: ball.left, 
            animationDelay: ball.delay, 
            width: ball.size, 
            height: ball.size, 
            fontSize: ball.size, 
            animationFillMode: "forwards"
          }}
        >
          ⚽
        </div>
      ))}
      <style>{`
        @keyframes fall {
          0% { transform: translateY(-100vh); opacity: 20; }
          10% { opacity: 1; }
          100% { transform: translateY(100vh); opacity: 20; }
        }
        .animate-fall {
          animation: fall 3s ease-in forwards;
          position: absolute;
        }
      `}</style>
    </div>
  );
};

export default BallDropAnimation;
